import { render, staticRenderFns } from "./AbocardWidget.vue?vue&type=template&id=f687ce04&"
import script from "./AbocardWidget.vue?vue&type=script&lang=ts&"
export * from "./AbocardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AbocardWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports